// Bebo-era flat palette — kept for server email templates + avatar fallbacks.
// NOT the UI design tokens: those live in shared/theme-tokens.ts (the source
// both platforms' theme CSS is generated from) and intentionally differ
// numerically from these hexes. Do not merge the two.
export const BRAND_BLUE = "#1875BF";
/** BirthdayAlarm green — the one accent/button colour in EMAIL (Nick 2026-09-08). */
export const EMAIL_GREEN = "#17a17e";
export const SKY_BLUE = "#00A7E1";
export const BRAND_ORANGE = "#F17720";
export const BRAND_MANGO = "#FFA630";
export const CRIMSON = "#E63946";
export const PERSIAN_GREEN = "#2A9D8F";
export const PROFILES_COLOR = BRAND_ORANGE;
export const PURPLE = "#7B2D8E";
export const COMMENT_BLUE_DARK = "#4A90D9";

export const USER_COLORS = {
  light: { fg: "#000000", bg: "#e7e5e4" },
  dark: { fg: "#000000", bg: "#44403c" },
} as const;

export const POD_COLORS = {
  light: { fg: "#6e7478", bg: "#ebebeb" },
  dark: { fg: "#FFFFFF", bg: "#003e56" },
} as const;
